

import { X, Monitor, Smartphone } from 'lucide-react';

export const PostPreview = ({ onClose }: { onClose: () => void }) => {
  return (
    <div className="fixed inset-0 z-50 bg-background flex flex-col">
      <div className="h-14 border-b flex items-center justify-between px-4 bg-card shrink-0">
        <div className="flex items-center space-x-2">
          <button className="p-2 bg-muted rounded-md"><Monitor className="w-4 h-4" /></button>
          <button className="p-2 hover:bg-muted text-muted-foreground rounded-md"><Smartphone className="w-4 h-4" /></button>
        </div>
        <button onClick={onClose} className="p-2 hover:bg-muted rounded-md flex items-center space-x-2">
          <span className="text-sm font-medium">Close Preview</span>
          <X className="w-4 h-4" />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-8 bg-muted/30">
        <div className="max-w-3xl mx-auto bg-background min-h-full border rounded-lg shadow-sm p-8 lg:p-12 prose dark:prose-invert">
          <h1>Preview Title</h1>
          <p>Preview content goes here...</p>
        </div>
      </div>
    </div>
  );
};
